import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import fieldKeys from './fieldKeys';

export default {
    [fieldKeys.ITEM_HAS_LEAD_TIME]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.lead_time"
            defaultMessage="This item is not eligible to be placed on hold."
        />
    ),
    [fieldKeys.ITEM_NOT_AVAILABLE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.unavailable"
            defaultMessage="This item is currently unavailable and cannot be placed on hold."
        />
    ),
    [fieldKeys.ITEM_ON_HOLD]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.onhold_for_another_buyer"
            defaultMessage="This item is already on hold for another customer."
        />
    ),
    [fieldKeys.SYSTEM_ERROR]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.system_error_hold"
            defaultMessage={`An error occurred processing your hold request. Please try again later or contact <a>trade@1stdibs.com</a> for assistance.`}
            values={{
                a: content => <Link href="mailto:trade@1stdibs.com">{content}</Link>,
            }}
        />
    ),
    [fieldKeys.MULTIPLE_QUANTITIES_AVAILABLE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.multiple_quantities"
            defaultMessage="Because this item has multiple quantities available, it is not eligible to be placed on hold at this time."
        />
    ),
    [fieldKeys.GENERAL_INQUIRY]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.general_inquiry"
            defaultMessage="A hold request cannot be completed as part of a general inquiry to a seller."
        />
    ),
    [fieldKeys.DUPLICATE_REQUEST]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.duplicate_request"
            defaultMessage="A hold request has already been requested on this item."
        />
    ),
    [fieldKeys.AUCTION_ITEM]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.hold.auction_item"
            defaultMessage="Auction items cannot be placed on hold."
        />
    ),
};
